import { PARTNER_PORTAL } from "../../shared/config";

/** The "powered by Flashadz" footer treatment carried across the portal shell. */
export function PortalFooter() {
  const [lead, brand] = PARTNER_PORTAL.poweredBy.split("Flashadz");
  return (
    <footer className="portal-foot">
      <span className="powered">
        {lead}
        <b>Flashadz</b>
        {brand}
      </span>
    </footer>
  );
}
